import './MixVisuallyHidden.css';

import { cn } from '../../utils/bem';

export const cnMixVisuallyHidden = cn('MixVisuallyHidden');
